import { render, staticRenderFns } from "./UploadExcel.vue?vue&type=template&id=95524b68&scoped=true"
import script from "./UploadExcel.vue?vue&type=script&lang=js"
export * from "./UploadExcel.vue?vue&type=script&lang=js"
import style0 from "./UploadExcel.vue?vue&type=style&index=0&id=95524b68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95524b68",
  null
  
)

export default component.exports